import React from 'react'
import * as classes from './downloadapp.module.scss'

const scrollToWaitlist = () => {
    if (typeof window === 'undefined') return
    const el = document.getElementById('waitlist')
    if (el) el.scrollIntoView({ behavior: 'smooth' })
    else window.location.href = '/#waitlist'
}

function DownloadApp() {
    return null
}

export default DownloadApp
